import { isString, keyBy, keys } from 'lodash'
import rawData from '../../../texts_data.js'
import { transportationMeans } from '../lib/emptyTransport'

const data = keyBy(rawData, x => x.id || x.es)

let language = "es"

const usedTexts = new Set([])

export function getText(id, forcedLang = null, strict = false) {
  const l = forcedLang || language
  usedTexts.add(id)

  if (data[id] && isString(data[id][l])) return data[id][l]
  else if (!strict) return id
  else return null
}

export function checkText(id, forcedLang = null) {
  const l = forcedLang || language
  return !!(data[id] && isString(data[id][l]))
}

function replaceTokens(id, words = []) {
  let _id = id
  words.forEach(word => { _id = _id.replace("$$", word) })
  return (_id)
}

export function getTextWithTokens(id, words, forcedLang = null) {
  const l = forcedLang || language
  usedTexts.add(id)
  const template = (data[id] && isString(data[id][l]) ? data[id][l] : (id))
  return replaceTokens(template, words)
}

export function replaceTokensWithDictionary(text, values) {
  let _text = text
  keys(values).forEach(k => {
    _text = _text.replace(new RegExp(`\\$${k}`, "g"), values[k])
  })
  return (_text)
}

export const replaceVouchersTokens = replaceTokensWithDictionary

export const setLanguage = (lang) => { language = lang }
export const getLanguage = () => language
export const getLocale = () => (language == "ch" ? "zh-cn" : "es-es")

export const translateCity = city => (
  isString(city)
    ? city
    : (getLanguage() == "ch" ? (city.chinese || city.name) : (city.name || city.chinese))
)

export const nameOrTitle = (x, lang = null) => (
  (lang || getLanguage()) == "ch" ? (x.title || x.name || x.englishName) : (x.name || x.englishName || x.title)
)

/**
 * transportation
 */

// #WARNING these are coupled with emptyTransport's keys

const _transportationMeansLabels = {
  none:     { icon: "", en: "None", es: "No seleccionado", ch: "未选择", includeTake: true },
  airplane: { icon: "✈️ ", en: "Airplane", es: "Avión", ch: "飞机", includeTake: true },
  train:    { icon: "🚄 ", en: "Train", es: "Tren", ch: "火车", includeTake: true },
  bus:      { icon: "🚌 ", en: "Bus", es: "Bus", ch: "大巴", includeTake: true },
  rental:   { icon: "🚙 ", en: "Rented car", es: "Coche de alquiler", ch: "租车自驾", includeTake: false },
  guide:    { icon: "🚙 ", en: "Guide's car", es: "Coche con guía", ch: "专车", includeTake: true },
  other:    { icon: "❓ ", en: "Other", es: "Otro", ch: "其它", includeTake: true },
  private:  { icon: "🚙 ", en: "Private car (?)", es: "Coche privado (?)", ch: "私家车(可能有错误)", includeTake: true },
}

export const getTransportationKeys = () => transportationMeans

export const transportationIncludesTake = k => _transportationMeansLabels[k].includeTake

export function getTransportationLabel(k, { forceLanguage, withIcon } = { forceLanguage: null, withIcon: false }) {
  const t = _transportationMeansLabels[k]
  const l = forceLanguage || getLanguage()
  return `${withIcon ? t.icon : ""}${t[l] || t.es}`
}

export function getTransportationTexts(k) {
  return _transportationMeansLabels[k]
}

/**
 *
 */

export function getRecoverPasswordEmail(username, link) {
  return {
    title: "重设密码 / Reestablece tu contraseña",

    plainText: `点击进入此链接给用户"${username}”.重设密码。此链接将在短时间内失效，但是可以重复申请 \n${link}\n\nUtiliza este enlace para reestablecer tu contraseña para el usuario "${username}". Recuerda que el enlace caducará pronto, pero puedes volver a solicitarlo. \n${link}`,

    html: `<h1>重设密码 / Reestablece tu contraseña</h1>
<p>使用此链接重新设定用户密码</p>
<p>此链接将在短时间内失效，但是可以重复申请</p>
<p><a href="${link}"> 链接</a></p>
<p>如果此链接无效请复制地址: ${link}</p>
<p>密码至少需要10个字符保障安全</p>
<br />
<p>Utiliza este enlace para reestablecer tu contraseña para el usuario "${username}".</p>
<p>Recuerda que el enlace caducará pronto, pero puedes volver a solicitarlo.</p>
<b><a href="${link}">Enlace para resetear la contraseña</a></b>
<p>Si no te funciona el enlace, cópialo: ${link}</p>
<p>La contraseña debe tener al menos 10 caracteres. No me pongais todos "chinespain2016" o algo así, que os veo venir 😉.</p>`
  }
}
